import {connect} from "react-redux";
import Button from "react-bootstrap/Button";
import {ArrowClockwise, CloudArrowDown} from "react-bootstrap-icons";
import Modal from "react-bootstrap/Modal";
import {Col, OverlayTrigger, ProgressBar, Row, Tooltip} from "react-bootstrap";
import React, {useEffect, useMemo, useState} from "react";
import './downloadManager.css';
import {
    addItemsToQueue,
    clearQueueProgress, refreshItemsInQueue, removeItemsFromQueue, resetQueueProgress,
    updateQueueProgress,
    updateShowDownloadManager
} from "../../action/download";
import fileDownload from "js-file-download";
import { X,FileEarmarkArrowDown } from "react-bootstrap-icons"
import axiosHandler from "../../services/https";
import MapitalyModal from "../MapitalyModal";

const DownloadManager = ({ isAuthenticated, user, downloadQueue, showDownloadManager, updateQueueProgress, updateShowDownloadManager, clearQueueProgress, resetQueueProgress, removeItemsFromQueue, refreshItemsInQueue }) => {

    // modal for communication --------------------
    const defaultModal = {
        modalTitle: "",
        modalText: "",
        confirmText: "",
        cancelText: "",
        show: false,
        handleClose: () => {
            updateModal({show: false});
        },
        handleHide: null,
        handleConfirm: null,
        handleCancel: null
    };
    const [modal, setModal] = useState(defaultModal);
    const [showLimitPopup, setShowLimitPopup] = useState(false);
    const [dailyDownloadLimit, setDailyDownloadLimit] = useState(0)

    const updateModal = (updates, reset = false) => {
        const placeholder = reset ? defaultModal : modal;
        setModal({...placeholder, ...updates});
    }
    const popupError = (message) => {
        updateModal({
            modalText: message,
            show: true
        });
    }

    const progressHandler = (progressEvent) => {
        const downloadInQueue = downloadQueue.find(elem => {
            return elem.url === progressEvent.event.target.responseURL.split('?auth=')[0];
        });
        updateQueueProgress([
            {...downloadInQueue, progress: progressEvent.progress, status: progressEvent.event.target.status, statusText: progressEvent.event.target.statusText}]
        );
    }

    const errorHandler = (errorEvent) => {
        const downloadInQueue = downloadQueue.find(elem => {
            return elem.url === errorEvent.config.url.split('?auth=')[0];
        });
        updateQueueProgress([{
            ...downloadInQueue,
            progress: 1,
            status: errorEvent.code,
            statusText: errorEvent.message
        }]);
        if (errorEvent.response && errorEvent.response.data && errorEvent.response.data.type === 'text/html') {
            errorEvent.response.data.text().then((result) => {
                const domParser = new DOMParser();
                const resultDom = domParser.parseFromString(result, 'text/html');
                updateQueueProgress([{
                    ...downloadInQueue,
                    progress: 1,
                    status: errorEvent.code,
                    statusText: resultDom.body.textContent.trim()
                }]);
            });
        }
    }

    const downloadHandler = (downloadResult) => {
        const downloadInQueue = downloadQueue.find(elem => {
            return elem.url === downloadResult.config.url.split('?auth=')[0];
        });
        let filename = undefined;
        if (downloadInQueue && downloadInQueue.filename) {
            filename = downloadInQueue.filename;
            if (filename.indexOf('.') < 0) {
                filename += '.jpg'; // fallback
            }
        }
        let headerLine = downloadResult.headers['content-disposition'];
        if (headerLine) {
            let startFileNameIndex = headerLine.indexOf('"') + 1
            let endFileNameIndex = headerLine.lastIndexOf('"');
            if (filename !== headerLine.substring(startFileNameIndex, endFileNameIndex)) {
                filename = headerLine.substring(startFileNameIndex, endFileNameIndex);
                updateQueueProgress([
                    {...downloadInQueue, actualFilename: filename}]
                );
            }
        }
        fileDownload(downloadResult.data, filename);
    }

    const removableElements = downloadQueue.filter(queueItem =>
        (queueItem.progress === 1 && queueItem.status === 'ERR_CANCELED' && (!queueItem.hasOwnProperty('refresh') || !queueItem.refresh))
    );
    const refreshableElements = downloadQueue.filter(queueItem =>
        (queueItem.hasOwnProperty('refresh') && queueItem.refresh)
    );
    const newElements = downloadQueue.filter(queueItem =>
        (!queueItem.hasOwnProperty('pending') || !queueItem.pending) && !queueItem.hasOwnProperty('xhr') && !queueItem.hasOwnProperty('abortController') && queueItem.progress == null
    );
    const errorElements = downloadQueue.filter(queueItem =>
        (queueItem.progress === 1 && queueItem.status !== 200 && (!queueItem.hasOwnProperty('refresh') || !queueItem.refresh))
    );
    const completedElements = downloadQueue.filter(queueItem =>
        (queueItem.progress === 1 && queueItem.status === 200)
    );
    const activeElements = downloadQueue.filter(queueItem =>
        queueItem.hasOwnProperty('xhr') && queueItem.hasOwnProperty('abortController') && queueItem.progress && queueItem.progress < 1
    );
    const pendingElements = downloadQueue.filter(queueItem =>
        (queueItem.hasOwnProperty('pending') && queueItem.pending) && !queueItem.hasOwnProperty('xhr') && !queueItem.hasOwnProperty('abortController') && queueItem.progress == null
    );

    const deleteQueue = () => {
        const itemsToRemove = downloadQueue.filter(queueItem =>
            (queueItem.progress === 1 && queueItem.status === 'ERR_CANCELED' && (!queueItem.hasOwnProperty('refresh') || !queueItem.refresh))
        );
        if (itemsToRemove && itemsToRemove.length) {
            removeItemsFromQueue(itemsToRemove);
        }
    }

    const refreshQueue = () => {
        const itemsToRefresh = downloadQueue.filter(queueItem =>
            (queueItem.hasOwnProperty('refresh') && queueItem.refresh)
        );
        if (itemsToRefresh && itemsToRefresh.length) {
            refreshItemsInQueue(itemsToRefresh);
        }
    }

    const updateQueue = () => {
        // quante xhr posso sottomettere in questo momento?
        const maxNumberOfDownloadsInQueue = parseInt(process.env.REACT_APP_MAPIT_DOWNLOAD_MANAGER_LIMIT ? process.env.REACT_APP_MAPIT_DOWNLOAD_MANAGER_LIMIT : 0);
        const elementsActuallyAddable = (newElements.length + pendingElements.length);
        const numElementsAddable = maxNumberOfDownloadsInQueue > 0 ? (maxNumberOfDownloadsInQueue - activeElements.length) : elementsActuallyAddable;
        if (numElementsAddable > 0 && elementsActuallyAddable > 0) {
            // chiamo la count
            // axiosHandler.getInstance().get(`${process.env.REACT_APP_MAPIT_API_URL}${process.env.REACT_APP_MAPIT_DOWNLOADS_COUNT}`).then((countResponse) => {
            // const count = parseInt(countResponse.data);
            const updatedElementsInQueue = [];
            let itemsToAddXhr = newElements.slice(0, numElementsAddable);
            const itemsToSuspend = newElements.slice(numElementsAddable);
            if (itemsToAddXhr.length < numElementsAddable && itemsToSuspend.length === 0) {
                // devo scongelare qualche elemento suspended
                const remainingItems = numElementsAddable - itemsToAddXhr.length;
                itemsToAddXhr = itemsToAddXhr.concat(pendingElements.slice(0, remainingItems)); // li metto qua
            }
            // popupError("Download limit exceeded"); // in caso di errore con la count
            itemsToAddXhr.forEach(downloadItem => {
                // if (count - itemsToAddXhr.length >= 0) {
                // devo impostare xhr e abortController nelle chiamate in coda
                downloadItem['abortController'] = new AbortController();
                downloadItem[`xhr`] = axiosHandler.getInstance().request({
                    url: downloadItem.url,
                    method: "GET",
                    responseType: "blob", // important
                    onDownloadProgress: progressHandler,
                    signal: downloadItem['abortController'].signal
                }).then(downloadHandler).catch(errorHandler);
                downloadItem['pending'] = false;
                updatedElementsInQueue.push({
                    ...downloadItem,
                    url: downloadItem.url,
                    progress: downloadItem.progress,
                    status: downloadItem.status,
                    statusText: downloadItem.statusText,
                    filename: downloadItem.filename,
                    xhr: downloadItem.xhr,
                    abortController: downloadItem.abortController,
                    pending: downloadItem.pending
                })
                // } else {
                //     updatedElementsInQueue.push({
                //         ...downloadItem,
                //         url: downloadItem.url,
                //         progress: 1,
                //         status: 403,
                //         statusText: 'Download limit exceeded'
                //     });
                // }
            });
            itemsToSuspend.forEach(downloadItem => {
                // lo segno come pending
                downloadItem['pending'] = true;
                updatedElementsInQueue.push({
                    ...downloadItem,
                    url: downloadItem.url,
                    progress: downloadItem.progress,
                    status: downloadItem.status,
                    statusText: downloadItem.statusText,
                    pending: downloadItem.pending
                })
            });
            updateQueueProgress(updatedElementsInQueue);
            // }).catch(error => {
            //     popupError('Error getting account information', error);
            //     // rimuovo le chiamate che dovevo contare, chiudendo il download manager
            //     removeItemsFromQueue([newQueueItems], true);
            // });
        }
    }

    //isDailyLimitReached useEffect per controllare il raggiungimento del limite di download per un singolo utente
    const isDailyLimitReached = async () => {
        try {
            const countResponse = await axiosHandler.getInstance().get(`${process.env.REACT_APP_MAPIT_API_URL}${process.env.REACT_APP_MAPIT_DOWNLOADS_COUNT}`);
            const count = parseInt(countResponse.data, 10);
            console.log("Count download giornalieri:", count)
            setDailyDownloadLimit(count)
            return downloadQueue.length >= count;
        } catch (error) {
            console.error("Errore nel fetch di count download giornalieri:", error);
            return false;
        }
    };

    //UseEffect per isDailyLimitReached
    useEffect(() => {
        const checkDailyLimit = async () => {
            const limitReached = await isDailyLimitReached();
            console.log("raggiunto limite download gionralieri?", limitReached, dailyDownloadLimit);
            if (limitReached) {
                setShowLimitPopup(true);
            } else {
                setShowLimitPopup(false);
            }
        };
    
        checkDailyLimit();
    }, [downloadQueue.length]);

    // garbage collector - gli elementi cancellati devono essere rimossi con questa azione
    useMemo(() => {
        console.log("Removable elements in queue", newElements);
        deleteQueue();
    },[
        removableElements.length
    ]);

    // refresh collector - gli elementi con valore refresh devono essere reinizializzati con questa azione
    useMemo(() => {
        console.log("Refreshable elements in queue", newElements);
        refreshQueue();
    },[
        refreshableElements.length
    ]);

    // new collector - gli elementi nuovi
    useMemo(() => {
        console.log("New elements in queue", newElements);
        if (newElements && newElements.length) {
            updateQueue();
        }
    },[
        newElements.length
    ]);

    // error collector - gli elementi in errore
    useMemo(() => {
        console.log("Error elements in queue", errorElements);
        if (errorElements && errorElements.length) {
            updateQueue();
        }
    },[
        errorElements.length
    ]);

    // completion collector - gli elementi completati
    useMemo(() => {
        console.log("Completed elements in queue", completedElements);
        if (completedElements && completedElements.length) {
            updateQueue();
        }
    },[
        completedElements.length
    ]);

    // active collector - gli elementi attivi
    useMemo(() => {
        console.log("Active elements in queue", activeElements);
    },[
        activeElements.length
    ]);

    // pending collector - gli elementi pending
    useMemo(() => {
        console.log("Pending elements in queue", activeElements);
    },[
        pendingElements.length
    ]);

    const downloadStatusColor = (downloadItem) => {
        let result = undefined;
        if (downloadItem.status === 200 && downloadItem.progress === 1) {
            result = 'success';
        }
        return result;
    }

    const downloadCountByStatusColor = (downloadQueue) => {
        let result = '#DC3545'; // in progress
        const inProgressDownloads = downloadQueue.filter(downloadItem => downloadItem.status === 200).length;
        const completedDownloads = downloadQueue.filter(downloadItem => downloadItem.status === 200 && downloadItem.progress === 1).length;
        if (completedDownloads > 0) {
            if (completedDownloads === inProgressDownloads) {
                result = '#198754'; // done
            } else {
                result = '#ffa500'; // partially in progress
            }
        }
        return result;
    }

    const renderTooltip = (...props) => {
        return (
            <Tooltip id="button-tooltip">
                {props.filename}
            </Tooltip>
        );
    }

    const getFilename = (downloadItemFilename) => {
        const filenameArray = downloadItemFilename.split('.');
        let ext = '';
        if (downloadItemFilename.indexOf('.') > -1) {
            ext = filenameArray[filenameArray.length-1];
        }
        const filenameTextCleaned = downloadItemFilename.replace(/_/g, ' ').replace('.' + ext, '').replace(/\./g, ' - ');
        return filenameTextCleaned + (ext ? ' (' + ext.toUpperCase() + ')' : '')
    }

    useEffect(() => {
        if (!isAuthenticated || !user) {
            removeItemsFromQueue();
        }
    }, [isAuthenticated, user]);

    return (
        <>
            {downloadQueue.length > 0 && !showDownloadManager &&
                <Button className="download-manager-button" onClick={() => {
                    updateShowDownloadManager(true);
                }}>
                    <CloudArrowDown style={{
                        width: "30px",
                        height: "30px"
                    }}/>
                    {
                        downloadQueue.filter(downloadItem => downloadItem.status === 200).length > 0 &&
                            <div className="download-count" style={{backgroundColor: downloadCountByStatusColor(downloadQueue) }}>{downloadQueue.filter(downloadItem => downloadItem.status === 200).length}</div>
                    }
                </Button>
            }
            <Modal
                centered
                size="lg"
                show={downloadQueue.length && showDownloadManager} onHide={() => {
                updateShowDownloadManager(false);
            }}
                className="download-queue">
                <Modal.Header closeButton>
                    <Modal.Title>Download Manager</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div id="download-manager">
                        {
                            downloadQueue.map((downloadItem) =>
                                <Row style={{paddingRight: "5px"}}
                                     className="justify-content-between align-items-center"
                                     key={downloadItem.filename + '-' + downloadItem.index}>
                                    <Col className='col'>
                                        {/*<div>{downloadItem.name}</div>*/}
                                        <div style={{fontSize: '13px'}}>
                                            {getFilename(downloadItem.filename)}
                                            { downloadItem.actualFilename &&
                                                <div>
                                                    <FileEarmarkArrowDown /> &nbsp;
                                                    <span style={{fontSize: 'smaller', verticalAlign: 'bottom'}}>{getFilename(downloadItem.actualFilename)}</span>
                                                </div>
                                            }
                                        </div>
                                        {/*<div className="mapitaly-tooltip">{downloadItem.name}<span className="tooltiptext">{downloadItem.filename}</span></div>*/}
                                    </Col>
                                    <Col className='col-auto'>
                                        <div style={{fontSize: '13px'}}>{downloadItem.status === 200 ? ((!downloadItem.pending ? ((downloadItem.progress ? Math.round(downloadItem.progress * 100) : 0) + " %") : '')) : ''}</div>
                                    </Col>
                                    <Col className='col-3' style={{
                                        overflow: "auto",
                                        maxHeight: "60px"
                                    }}>
                                        {!downloadItem.statusText || downloadItem.statusText.toLowerCase() === 'ok' ? (
                                            <ProgressBar className={!downloadItem.progress || !downloadItem.statusText ? 'waiting-progress' : ''} variant={downloadStatusColor(downloadItem)} now={downloadItem.progress ? Math.round(downloadItem.progress * 100) : 0} />
                                        ) : (<div style={{fontSize: '13px'}}>{downloadItem.statusText}</div>)}
                                    </Col>
                                    <Col className='col-auto'>
                                        <X onClick={() => {
                                                clearQueueProgress([downloadItem])
                                        }} />
                                        <ArrowClockwise onClick={() => {
                                            resetQueueProgress([downloadItem])
                                        }} />
                                    </Col>
                                </Row>
                            )
                        }
                    </div>
                </Modal.Body>
                {/* Modale per raggiungimento di limite di download size="sm"*/}
                <Modal centered show={showLimitPopup} onHide={() => setShowLimitPopup(false)}>
            <Modal.Header closeButton>
                <Modal.Title>Download Limit Reached</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                You have currently reached the daily limit for downloads.
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={() => setShowLimitPopup(false)}>
                    Close
                </Button>
            </Modal.Footer>
        </Modal>
            </Modal>
            
            <MapitalyModal className={"bottom"} {...modal}></MapitalyModal>
        </>
    )
}

const mapStateToProps = state => ({
    downloadQueue: state.download.queue,
    showDownloadManager: state.download.showDownloadManager,
    user: state.auth.user,
    isAuthenticated: state.auth.isAuthenticated,
});
export default connect(mapStateToProps, {
    addItemsToQueue,
    updateQueueProgress,
    updateShowDownloadManager,
    clearQueueProgress,
    resetQueueProgress,
    removeItemsFromQueue,
    refreshItemsInQueue
})(DownloadManager)
